module.exports = __webpack_public_path__ + "static/space_Transport-e6d97285d2e9ee5c2d516a2e150dee8d.svg";